import { useMemo } from "react"
import { Button } from "@chakra-ui/react"

import { setOpenModal, useDappDispatch } from "#/redux-state"
import { useContinueButton } from "#/shared/hooks"

export default function DepositContinueButton() {
  const { isDisabled } = useContinueButton()
  const dispatch = useDappDispatch()

  const buttonVariant = useMemo(
    () => (isDisabled ? "disabled" : "primaryBlack"),
    [isDisabled],
  )

  return (
    <Button
      variant={buttonVariant}
      color="primary.white.100"
      size="large"
      h="64px"
      isDisabled={isDisabled}
      onClick={() => dispatch(setOpenModal("deposit"))}
    >
      Continue
    </Button>
  )
}
